"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
const GridColumnDataDisplayedType_1 = require("../GridColumnDataDisplayedType");
class DateRenderer {
    canRender(o) {
        return o instanceof Date;
    }
    render(ctx, o) {
        ctx.html((0, fmko_ts_common_1.formatDate)(o));
        ctx.setColumnDataDisplayType(GridColumnDataDisplayedType_1.GridColumnDataDisplayedType.DATE);
    }
}
exports.default = DateRenderer;
//# sourceMappingURL=DateRenderer.js.map